import { Link } from 'react-router-dom';
import { stats } from '@/mocks/articles';

export default function AboutIntro() {
  return (
    <section className="py-12 md:py-16">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 items-center">
          <div className="lg:col-span-5">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border border-foreground-200 text-foreground-500">
              平台简介
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-4 leading-tight">
              为什么选择
              <br />
              <span className="text-accent-500">黑料吃瓜网</span> ✨
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mt-6 max-w-md">
              黑料吃瓜网是领先的娱乐资讯聚合平台，每日为超过10万吃瓜群众提供最新、最热的娱乐圈动态。我们坚持真实、快速、全面的报道理念，让每一位用户都能第一时间吃到最新鲜的"瓜"。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 mt-6 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors underline underline-offset-4"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="relative">
              <div className="flex justify-end gap-3 mb-4">
                {stats.slice(0, 2).map((stat, i) => (
                  <div
                    key={i}
                    className="bg-background-100 rounded-xl p-4 md:p-5 text-right min-w-[120px]"
                  >
                    <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                      {stat.value}
                    </p>
                    <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
              <div className="flex gap-3">
                <div className="w-[45%] aspect-[3/4] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20digital%20newsroom%20with%20multiple%20screens%20displaying%20entertainment%20news%2C%20warm%20ambient%20lighting%2C%20professional%20media%20environment%2C%20editorial%20style%2C%20clean%20workspace%2C%20soft%20shadows%2C%20contemporary%20office%20design&width=600&height=800&seq=about-intro-01&orientation=landscape"
                    alt="黑料吃瓜网编辑团队"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-[55%] flex flex-col gap-3">
                  <div className="aspect-[16/9] rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Team%20of%20journalists%20collaborating%20in%20modern%20newsroom%2C%20warm%20lighting%2C%20professional%20atmosphere%2C%20digital%20screens%2C%20editorial%20teamwork%2C%20creative%20workspace%2C%20soft%20natural%20light%2C%20contemporary%20office&width=900&height=506&seq=about-intro-02&orientation=landscape"
                      alt="黑料吃瓜网团队"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex gap-3">
                    {stats.slice(2, 4).map((stat, i) => (
                      <div
                        key={i}
                        className="flex-1 bg-background-100 rounded-xl p-3 md:p-4 text-right"
                      >
                        <p className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                          {stat.value}
                        </p>
                        <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}